import axios from "axios";
export default class HttpClient {
    async get(url) {
        //url = "http://localhost/" + url;
        var baseUrl = window.location.origin;
        url = baseUrl + "/" + url;
        console.log("get request =" + url);
        return axios.get(url);
    }
}
//# sourceMappingURL=HttpClient.js.map